import React from "react";
import PropTypes from "prop-types";
import BurgerMenuItem from "web/react/components/burger-menu/burger-menu-item/burger-menu-item";
import BurgerMenuSecondaryHeader from "web/react/components/burger-menu/burger-menu-secondary-header/burger-menu-secondary-header";
import style from "./burger-menu-category-menu.css";

function BurgerMenuCategoryMenu({
    selectedCategory,
    onCategoryClick,
    onBackToMainClick,
    category,
}) {
    return (
        <div>
            <BurgerMenuSecondaryHeader
                renderText={selectedCategory}
                onClickEvent={onBackToMainClick}
            />
            <ul>
                {category.menus &&
                    category.menus.map((menu) => {
                        return (
                            <BurgerMenuItem
                                key={menu.display_name}
                                renderText={menu.display_name}
                                renderChevron={true}
                                onClickEvent={() => onCategoryClick(menu)}
                            />
                        );
                    })}
                {category.links &&
                    category.links.map((link) => {
                        return (
                            <BurgerMenuItem key={link.url} renderText={link.text} href={link.url} />
                        );
                    })}
            </ul>

            {category.trend_menus && (
                <div>
                    <div className={style.categorySubHeading}>{category.trend_heading}</div>
                    <ul>
                        {category.trend_menus.map((trendMenu) => {
                            return (
                                <BurgerMenuItem
                                    key={trendMenu.name}
                                    renderText={trendMenu.display_name}
                                    renderChevron={true}
                                    onClickEvent={() => onCategoryClick(trendMenu)}
                                />
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default BurgerMenuCategoryMenu;

BurgerMenuCategoryMenu.propTypes = {
    category: PropTypes.object,
    selectedCategory: PropTypes.string,
    onBackToMainClick: PropTypes.func.isRequired,
    onCategoryClick: PropTypes.func.isRequired,
};

BurgerMenuCategoryMenu.defaultProps = {
    category: {},
    selectedCategory: "",
};
